export default __webpack_public_path__ + "static/media/Maddie 9781408312988.c4387cbd.jpg";